module.exports = __webpack_public_path__ + "img/A2_HQ01.32ea9048.jpg";